export const PROPERTY_DATA_NAME = 'data-name';
